import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 14,
	viewBox: "0 0 20 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.5875 4.67C14.8658 2.21333 12.625 0.5 9.99998 0.5C8.08998 0.5 6.29998 1.44833 5.21498 3.00417C2.06665 3.12 -0.404185 5.935 0.0549815 9.19833C0.434981 11.8967 2.87082 13.8333 5.59498 13.8333H7.49998H9.16665V8.83333H7.42748H7.36248C7.05248 8.83333 6.89748 8.45917 7.11665 8.24L9.75415 5.6025C9.88998 5.46667 10.11 5.46667 10.2458 5.6025L12.8833 8.24C13.1025 8.45917 12.9475 8.83333 12.6375 8.83333H12.5725H10.8333V13.8333H12.5H15.2216C17.5891 13.8333 19.7108 12.1225 19.9716 9.77C20.27 7.06917 18.2058 4.76583 15.5875 4.67Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgImport);
export { ForwardRef as ReactComponent };
